const Design = () => import(/* webpackChunkName: "design-group" */ '@/views/design/Design')

export default [
  {
    path: 'design',
    name: 'design',
    components: {
      studyContent: Design
    },
    meta: {
      title: 'eCRF设计'
    }
  }
]
